<app-sub-header [currMenu]="currMenu$" [memberInfo]="memberInfo$"></app-sub-header>

<form [formGroup]="form">

  <input type="hidden" id="memNo" formControlName="memNo" />

  <div class="inner-wrap">
    <div class="result">
      <div class="txt">비밀번호 재설정</div>
      <div class="pw">
        <p>
          <input type="password" id="password" formControlName="password" [ngClass]="{formErrors:formErrors['password']}" placeholder="새 비밀번호 (6~20자의 영문 대소문자 및 숫자 조합)" />
          <span *ngIf="formErrors['password']" class="cred ml5">{{formErrors['password']}}</span>
        </p>
        <p>
          <input type="password" id="passwordConfirm" formControlName="passwordConfirm" [ngClass]="{formErrors:formErrors['passwordConfirm']}" placeholder="새 비밀번호 재입력" pattern="{{ this.form.get('password').value }}" />
          <span *ngIf="formErrors['passwordConfirm']" class="cred ml5">{{formErrors['passwordConfirm']}}</span>
        </p>
      </div>
      <button class="btn1" (click)="setChangePassword()">확인</button>
    </div>
  </div>

</form>
